export function isTableColorPickerOpen() {
  const active = document.activeElement;
  return (
    active instanceof HTMLInputElement &&
    active.type === "color" &&
    typeof active.closest === "function" &&
    Boolean(active.closest(".pr-table-menu"))
  );
}
